import { useState, useMemo, useEffect } from 'preact/hooks';
import useApp from '../context/AppContext';
import { useToaster } from '../context/ToasterContext';
import Table from '../components/ui/Table';
import useEvent from '../hooks/useEvent';
import FormEvent from '../components/ui/FormEvent';

export default function FormEventWeight(_route) {
    const { animals, events, isDataLoaded } = useApp();
    if (!isDataLoaded) {
        return (
            <div class="text-center">
                <div class="spinner-border text-warning" role="status">
                    <span class="visually-hidden">Loading ...</span>
                </div>
            </div>
        );
    }
    const addToast = useToaster();
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
    const { getEventInfo, saveEvent } = useEvent();
    const [eventInfo, setEventInfo] = useState(getEventInfo(_route, animals, events));
    const event = eventInfo.event;
    const [weight, setWeight] = useState(null);
    const selectedAnimals = eventInfo.selectedAnimals;
    const animalWeightEvents = events.filter(event => event.type == 3 && event.animalId == selectedAnimals[0].id);
    const [currentGmq, setCurrentGmq] = useState(null);
    const columnsWeighting = [
        { label: "Poids", accessor: "weight", sortable: false },
        { label: "Date", accessor: "date", sortable: false },
        { label: "GMQ g/j", accessor: "gmq", sortable: false },
    ];
    eventInfo.isCreateEvent = typeof _route.id == "undefined" || _route.id == "";
    eventInfo.isUnique = _route.animal_id;

    const computeGMQ = (startWeight, endWeight, startDate, endDate) => {
        const sd = new Date(startDate);
        const ed = new Date(endDate);
        return (endWeight - startWeight) / Math.ceil((ed.getTime() - sd.getTime()) / 86400000) * 1000;
    };

    useEffect (() => {
        setWeight(event && event.weight ? event.weight : null);
        window.scrollTo(0, 0);
    }, []);

    const gmqTable = useMemo(() => {
        const t = [];
        let gmq = 0;
        let prevEvt;
        animalWeightEvents.forEach((evt, i) => {
            gmq = 0;
            if (animalWeightEvents[i + 1]) {
                // events array is antechronological sorted
                prevEvt = animalWeightEvents[i + 1];
                gmq = computeGMQ(prevEvt.weight, evt.weight, prevEvt.dateApi, evt.dateApi);
            }
            t.push({ id: evt.id, value: gmq, date: evt.dateApi, weight: evt.weight });
        })
        return t;
    }, []);

    const cellFormatWeighting = (value, accessor, data) => {
        let str = value;
        switch (accessor) {
            case 'date':
                str = new Date(data.dateApi).toLocaleDateString();
                break;
            case 'gmq':
                let gmq = gmqTable.find(g => parseInt(g.id) == parseInt(data.id));
                str = gmq ? Math.round(gmq.value) : "---";
                break;
        }
        return str;
    };

    const handleCurrentGmqChange = (e) => {
        let inputWeight = e.target.value;
        if (inputWeight == "" || _route.id) {
            setCurrentGmq(null);
            return;
        }
        let gmq = 0;
        if (gmqTable.length > 0) {
            gmq = computeGMQ(gmqTable[0].weight, parseFloat(inputWeight), gmqTable[0].date, eventInfo.date);
        }
        setCurrentGmq(Math.round(gmq));
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        e.returnValue = '';
        const fields = e.target;
        const formAnimal = {
            weight: parseFloat(fields.weight.value.replace(',', '.')),
        }
        const formEvent = {
            date: fields.date.value,
            notes: fields.notes.value,
            type: 3,
            ...formAnimal
        }
        setSubmitButtonDisabled(true);
        saveEvent(selectedAnimals, formEvent, formAnimal, _route, true).then((responses) => {
            let error = 0;
            responses.forEach(response => {
                addToast(response.type, response.message);
                if (response.type != 'success') error++;
            })
            setSubmitButtonDisabled(false);
            if (error == 0) history.go(-1);
        });
    }

    return (
        <FormEvent title="Poids"
            onSubmit={handleSubmit}
            eventInfo={eventInfo}
            message=""
            submitButtonDisabled={submitButtonDisabled}
            setEventInfo={setEventInfo}>
            <div class="form-floating mb-3">
                <input class="form-control" id="weight" type="number" name="weight" step="0.1" value={weight} onInput={handleCurrentGmqChange} />
                <label class="form-label" for="poids">Poids</label>
            </div>
            {currentGmq && <span>GMQ : {currentGmq} g/j</span>}
            <div class="mt-4">
                <Table id="events" caption="Anciennes pesées" columns={columnsWeighting}
                    selectable={false} data={animalWeightEvents} cellFormat={cellFormatWeighting} />
            </div>
        </FormEvent>
    );
}